import Head from "next/head";
import { make as CharmsPage } from "../../src/info/CharmsPage.bs.js";

export default function CharmsRoute({ charms, charmOdds }) {
  return (
    <>
      <Head>
        <title>TFT Set 12 Charms Info</title>
      </Head>
      <CharmsPage charms={charms} charmOdds={charmOdds} />
    </>
  );
}

//
export async function getStaticProps({ locale }) {
  const charmsResp = await fetch(
    `https://ap.tft.tools/static/s12/charms_${locale}.json`,
  );
  const charms = await charmsResp.json();
  const charmOddsResp = await fetch(
    `https://ap.tft.tools/static/s12/charm_odds.json`,
  );
  const charmOdds = await charmOddsResp.json();

  return {
    props: {
      charms,
      charmOdds,
    },
    revalidate: 3600,
  };
}
